type careSymbolsType = {
  [key: string]: string
}

export const careSymbols: careSymbolsType = {
  // Wash
  '88_6191': 'care/wash/30-degree',
  '88_6192': 'care/wash/40-degree',
  '88_6193': 'care/wash/60-degree',
  '88_6194': 'care/wash/95-degree',
  '88_6195': 'care/wash/30-degree-delicate',
  '88_6196': 'care/wash/40-degree-delicate',
  '88_6197': 'care/wash/60-degree-delicate',
  '88_6198': 'care/wash/30-degree-very-delicate',
  '88_6199': 'care/wash/40-degree-very-delicate',
  '88_6200': 'care/wash/hand-wash',
  '88_6201': 'care/wash/no-wash',
  // Bleach
  '89_6202': 'care/bleach/no-bleach',
  '89_6203': 'care/bleach/bleach',
  '89_6204': 'care/bleach/non-chlorine-bleach',
  // Dry
  '92_6205': 'care/dry/no-tumble-dry',
  '92_6206': 'care/dry/tumble-dry-low-temp',
  '92_6207': 'care/dry/tumble-dry-medium-temp',
  // Iron
  '90_6208': 'care/iron/no-iron',
  '90_6209': 'care/iron/iron-low-temp',
  '90_6210': 'care/iron/iron-medium-temp',
  '90_6211': 'care/iron/iron-high-temp',
  // Clean
  '91_6212': 'care/clean/no-dry-clean',
  '91_6213': 'care/clean/p-only',
  '91_6214': 'care/clean/p-only-delicate',
  '91_6215': 'care/clean/f-only',
  '91_6216': 'care/clean/f-only-delicate',
  '91_6217': 'care/clean/no-wet-clean',
  '91_6218': 'care/clean/wet-clean',
  '91_6219': 'care/clean/wet-clean-delicate',
  '91_6220': 'care/clean/wet-clean-very-delicate',
}
